import { createContext, useContext, useEffect, useState } from "react";
import { UserDetails } from "../types";
import accountService from "../services/accountService";

interface AuthContextType {
    user: UserDetails | null;
    setUser: React.Dispatch<React.SetStateAction<UserDetails | null>>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [user, setUser] = useState<UserDetails | null>(null);

    useEffect(() => {
        setUser(accountService.getActiveUser());

        const unsubscribe = accountService.subscribe((status) => {
            if (status === true) {
                setUser(accountService.getActiveUser());
            } else {
                setUser(undefined);
            }
        })
        return () => {
            unsubscribe();
        }
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export function useAuth(): AuthContextType {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth must be used inside an AuthProvider");
    }
    return ctx;
}
